import { DataBean } from "../DataBean";

export class Machines extends DataBean {
  public async getMachinesCatalogPorPropiedades(
    properties: any,
    maxRows: number
  ): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "java.util.List_getMachinesCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async deleteMachines(idmachines: number): Promise<any> {
      return this.getCustomService("ProcessContractERP", "boolean_deleteMachines_Number", [idmachines]);
  }

  public async updateMachines(bean: any): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.orange.finance.processcontract.bean.Machines_updateMachines_com.orange.finance.processcontract.bean.Machines",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.orange.finance.processcontract.bean.Machines",
        },
      ]
    );
  }
}
